import { Injectable } from '@angular/core';

import { BaseEditService } from 'tms-lib';
import { Supplier, SupplierDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierShipperService extends BaseEditService<Supplier, SupplierDetails> {
  constructor() {
    super('SupplierShipper', $localize`Supplier Shipper`);
  }
}
